import { Form } from "antd";
import { useGlobalFilterContext } from "contexts/GlobalFilterContext";
import { isUndefined } from "lodash";
import React, { forwardRef, useEffect } from "react";
import { GithubSecretScanSupportAPI } from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, generateFormFields } from "utils/formUtils";

const GithubSecretScanHideSecretLiteralsSelection = forwardRef(({toolName},ref) => {
    const { globalFilterHash } = useGlobalFilterContext();
    const [form] = Form.useForm();

    useEffect(() => {
      const { cancel, promise } = GithubSecretScanSupportAPI.getGithubSecretScanToolConfig();
      promise.then((resData) => {
        const existingValue = resData?.config?.hideSecretLiteralsToggle;
        if (!isUndefined(existingValue)) {
          form.setFieldsValue({
            hideSecretLiteralsToggle: existingValue,
          });
        } else {
          form.setFieldsValue({
            hideSecretLiteralsToggle: false,
          });
        }
      });
      return cancel;
    }, [globalFilterHash, form]);

    const fields = [
      {
        name: "hideSecretLiteralsToggle",
        type: FieldTypes.BOOLEAN,
        label: "Hide Secret Literals",
        help: "Once enabled, the actual secret literal will not be included in finding or scan reports",
        inline: true,
      },
    ];


    return (
        <Form
        form={form}
        ref={ref}
        style={{ minWidth: 400 }}
        layout="horizontal"
        initialValues={{ hideSecretLiteralsToggle: false }}
        >
          {generateFormFields(fields)}
        </Form>
    );
  },
);

export default GithubSecretScanHideSecretLiteralsSelection;